import { render, staticRenderFns } from "./NotesListTable.vue?vue&type=template&id=087c6cae&"
import script from "./NotesListTable.vue?vue&type=script&lang=js&"
export * from "./NotesListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports